const loginAction = payload => {
    return {
        type: 'LOGIN_SUCCESS',
        payload
    }
}

export default loginAction